module.exports = __webpack_public_path__ + "img/pro_four_2.72436ba2.jpg";